// /* global ga */

Wee.fn.make('common', {
	init: function() {
		var replacingClass = '-is-replacing';

		$.set('pushPath', $._win.location.pathname);
		$.set('cdnUrl', $('ref:siteWrapper').data('cdn'));
		$.set('assetsUrl', $('ref:siteWrapper').data('assets'));

		this.chain();

		$.history.init({
			bind: {
				click: 'a:not([data-static])'
			},
			partials: 'title, .main',
			processErrors: true,
			request: {
				root: '/pjax/',
				error: function(xhr) {
					$._win.location = xhr.responseURL.replace('/pjax', '');
				}
			},
			begin: function(options) {
				$.set('pushPath', options.path);
				$(options.partials, $._body).addClass(replacingClass);
			},
			end: function(options) {
				$(options.partials, $._body).removeClass(replacingClass);

				if (typeof ga !== 'undefined') {
					ga('set', 'page', Wee.routes.uri().full);
					ga('send', 'pageview');
				}
			}
		});

		$('a').on('mousedown', function() {
			var $el = $(this);

			if ($el.css('outline-style') == 'none') {
				var outlineClass = '-no-outline';
				$el.addClass(outlineClass).on('blur', function() {
					$el.removeClass(outlineClass);
				}, {
					once: true
				});
			}
		}, {
			delegate: Wee._body
		});
	},

	/**
	 * Chain reusable functions
	 *
	 * @private
	 */
	chain: function() {
		var disabledClass = '-is-disabled';

		$.chain({
			'enable': function() {
				this.removeClass(disabledClass);

				return this;
			},
			'disable': function() {
				this.addClass(disabledClass);

				return this;
			},
			'enableItem': function() {
				this.removeClass(disabledClass)
					.siblings()
					.addClass(disabledClass);

				return this;
			}
		});
	},
	checkTrigger: function() {
		return Wee.$get('pushPath', false) === $._win.location.pathname ? 0 : 1;
	}
});
